module.exports = __webpack_public_path__ + "img/dc14ebc8c9ee8860bc69ea8ec528ab6.dcbe084b.jpg";